import { render, staticRenderFns } from "./_base-actions-menu.vue?vue&type=template&id=1a52473c&scoped=true&"
import script from "./_base-actions-menu.vue?vue&type=script&lang=js&"
export * from "./_base-actions-menu.vue?vue&type=script&lang=js&"
import style0 from "./_base-actions-menu.vue?vue&type=style&index=0&id=1a52473c&lang=sass&scoped=true&"
import style1 from "./_base-actions-menu.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52473c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VMenu,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a52473c')) {
      api.createRecord('1a52473c', component.options)
    } else {
      api.reload('1a52473c', component.options)
    }
    module.hot.accept("./_base-actions-menu.vue?vue&type=template&id=1a52473c&scoped=true&", function () {
      api.rerender('1a52473c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-actions-menu.vue"
export default component.exports